import createRouter from "./createRouter";
import LayoutContainer from "@/views/Layout/LayoutContainer.vue";

export const routes = [
  {
    path: '/schedule',
    component: LayoutContainer,
    redirect: '/schedule/my-schedule',
    children: [
      {
        path: 'my-schedule',
        name: 'MySchedule',
        component: () => import('@/views/Schedule/MySchedule.vue'),
        meta: {
          title: '我的日程'
        }
      },
    ]
  }
]

export default createRouter(routes);